export default __webpack_public_path__ + "static/media/spirals-no-1.9185153b.ogg";